import { gql } from '@apollo/client'

export const GET_PROJECT = gql`
  query ($id: String!) {
    getCampaign(id: $id) {
      isGlobal
      editable
      active
      id
      info
      team_info
      isaac_url {
        title
        url
      }
      children {
        id
        label_id
        global_status
        created_at
      }
      main_product_id
      name
      owner_id
      user {
        first_name
        email
        last_name
      }
      parent {
        id
        parent_id
        original_campaign_id
        global_status
        info
        team_info
        isaac_url {
          title
          url
        }
        user {
          first_name
          last_name
          email
        }
      }
      original_campaign_id
      original_campaign {
        label_id
      }
      parent_id
      unit_id
      unit {
        name
        id
        alias
      }
      label_id
      project_id
      created_at
#      gcdmLabel
      global_status
      artist {
        label_id
        bio
        facebook_id
        gcdm_info {
          company
          country
          genre
        }
        spotify_id
        instagram_id
        youtube_id
        twitter_id
        tiktok_id
        gfk_id
        gps_status
        id
        name
        opus_id
        social_media_kpi_facebook
        social_media_kpi_instagram
        social_media_kpi_twitter
        social_media_kpi_youtube
        social_media_kpi_spotify
        social_media_kpi_tiktok
        image_url_data {
          thumbnailUrl
          imageUrl
          headerUrl
        }
      }
    }
  }
`
